<div class="relatedto-main-container input d-flex justify-content-between align-items-center" [ngClass]="{'disable-component': disableType}" (document:click)="handleOutsideClick($event)">
  <div class="free-text-container">
    <input type="text" class="free-text" placeholder="Search Vendor" [(ngModel)]="searchText" (ngModelChange)="onSearchTextChange()" [disabled]="disableType"/>
  </div>
  <div class="search-results-main-container" *ngIf="filteredResults.length > 0">
    <ul class="search-list">
      <li class="list-item" *ngFor="let item of filteredResults" (click)="selectItem(item)">
        {{ item.displayName }}
      </li>
    </ul>
  </div>
</div>
